/**
 * ユーザー関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const TasksState = Record({
  id: null,
  status: '',
  room_name: '',
  title: '',
  user_name: '',
  updated_at: null,
  reservation_id: null
})

export { TasksState }
